(function() {
  if(navigator.userAgent.toLowerCase().indexOf('ucbs') > 0) {
    document.querySelector('html').setAttribute('class', 'uc4');
  }else if (/iphone/gi.test(navigator.userAgent)){
    let docEl = document.documentElement;
    docEl.style.fontSize = 100 / 750 * docEl.clientWidth + 'px';
    window.addEventListener('resize', function() {
      docEl.style.fontSize = 100 / 750 * docEl.clientWidth + 'px';
    });
  } else {
    let docEl = document.documentElement;
    docEl.style.fontSize = 100 / 750 * docEl.clientWidth + 'px';
    window.addEventListener('resize', function() {
      docEl.style.fontSize = 100 / 750 * docEl.clientWidth + 'px';
    });
  }
})();